import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import { ReactSortable } from "react-sortablejs";
import {
    getCategories,
    resetCategories,
    setCategories,
} from "../../../redux/actions";
import { ROLES } from "../../utils/constants";
import { numberWithCommas } from "../../utils/helper";
import useDidMountEffect from "../../utils/useDidMountEffect";

import "./style.scss";

const PostCategoryList = ({
    activeCategory,
    setActiveCategory,
    setCurrentPage,
    categories,
    totalAll,
    viewType,
}) => {
    const dispatch = useDispatch();

    const [move, setMove] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [puName, setPuName] = useState("");

    const userInformation = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        const url = window.location.pathname;
        const urlParts = url.split("/").filter((path) => path);
        const segment = urlParts.length > 0 ? urlParts[0].split("?") : "";

        if (segment && segment[0] !== "home") {
            setPuName(segment[0]);
            dispatch(getCategories({ all: true, creator: segment[0] }));
        }
    }, []);

    const handleCategoryChange = (category = null) => {
        if (typeof setCurrentPage === "function") setCurrentPage(1);
        setActiveCategory(category ? category : {});
    };

    const toggleMove = () => {
        setMove((move) => !move);
    };

    const handleSort = (sortedState) => {
        dispatch(setCategories(sortedState));
    };

    const updateCategoriesRank = () => {
        axios
            .patch("/api/categories/ranking", {
                type: "order",
                categories,
            })
            .then((response) => { })
            .catch((error) => {
                console.error({ error });
            });
    };

    useDidMountEffect(() => {
        if (!move) {
            updateCategoriesRank();
        }
    }, [move]);

    return (
        <div className="postCategoryList">
            <ul className="all">
                <li
                    className={`${activeCategory &&
                        Object.keys(activeCategory).length <= 0
                        ? "active"
                        : ""
                        } ${move ? "move" : ""}`}
                    onClick={() => handleCategoryChange()}
                    title="Show All"
                >
                    All {numberWithCommas(totalAll)}
                </li>
            </ul>
            <ReactSortable
                group="categories"
                tag="ul"
                className="categories"
                list={categories}
                setList={(newState) => handleSort(newState)}
                easing="cubic-bezier(0.785, 0.135, 0.15, 0.86)"
                onChoose={() => {
                    setIsDragging(true);
                }}
                onUnchoose={() => {
                    setIsDragging(false);
                }}
                delayOnTouchOnly={true}
                delay={1}
                touchStartThreshold="0"
                filter=".drag-ignore"
                preventOnFilter={true}
                ghostClass="sortable-ghost"
                disabled={!move}
                dragoverBubble={false}
                swapThreshold={1}
                swap
            >
                {categories.map((category) => {
                    return (
                        <li
                            key={category.id}
                            className={`categories__item ${activeCategory.id === category.id
                                ? "active"
                                : ""
                                } ${move ? "move" : ""} ${isDragging ? "dragging" : ""
                                }`}
                            onClick={() => handleCategoryChange(category)}
                            title={`Show ${category.name} Album`}
                        >
                            <span className="category__item-name">
                                {category.name} {" "} {numberWithCommas(category.posts_count)}
                            </span>
                        </li>
                    );
                })}
            </ReactSortable>
            {userInformation.role === ROLES.PU &&
                userInformation.login === puName && (
                    <ul>
                        <li
                            onClick={toggleMove}
                            className={`move-trigger ${move ? "move" : ""}`}
                        >
                            <i className="fa-solid fa-up-down-left-right"></i>
                        </li>
                    </ul>
                )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        categories: state.category.categories,
        totalAll: state.post.total_all,
    };
};

export default connect(mapStateToProps)(PostCategoryList);
